import { useCallback, useLayoutEffect, useRef, useState } from 'react'

type UseGalleryWidgetImageStateOptions = {
    src: string
}

export function useGalleryWidgetImageState({ src }: UseGalleryWidgetImageStateOptions) {
    const prevSrc = useRef(src)

    const [isLoaded, setIsLoaded] = useState(false)

    const onLoad = useCallback((e: React.SyntheticEvent<HTMLImageElement>) => {
        const image = e.target as HTMLImageElement
        if (!image.complete) return

        setIsLoaded(true)
    }, [])

    const [isError, setIsError] = useState(false)

    const onError = useCallback(() => {
        setIsError(true)
    }, [])

    useLayoutEffect(() => {
        if (prevSrc.current !== src) {
            setIsLoaded(false)
            setIsError(false)
            prevSrc.current = src
        }
    }, [src])

    const showPlaceholder = isError || !src

    return {
        isLoaded,
        onLoad,
        isError,
        onError,
        showPlaceholder,
    }
}
